import { Box, Button, Container, Text } from "@chakra-ui/react";

function Sandbox() {
  return (
    <Container mt={12} maxW="container.lg">
      <Text as="h2">Sandbox</Text>
      <Text as="h3">Buttons</Text>

      <Text as="h4">Primary</Text>
      <Box display="flex" gap="4">
        <Button variant="primary">Primary</Button>
        <Button variant="primary-outline">Primary outline</Button>
        <Button variant="primary-soft-outline">Primary soft outline</Button>
        <Button variant="primary-text">Primary text</Button>
      </Box>

      <Box display="flex" gap="4" mt="4">
        <Button isDisabled={true} variant="primary">Primary (disabled)</Button>
        <Button isDisabled={true} variant="primary-outline">Primary outline (disabled)</Button>
        <Button isDisabled={true} variant="primary-soft-outline">Primary soft outline (disabled)</Button>
        <Button isDisabled={true} variant="primary-text">Primary text (disabled)</Button>
      </Box>

      <Box display="flex" gap="4" mt="4">
        <Button size="xl">XL xlarge</Button>
        <Button size="lg">L large</Button>
        <Button size="md">MD medium</Button>
        <Button size="sm">SM small</Button>
        <Button size="xs">XS xsmall</Button>
      </Box>

      <Text as="h4" mt={8}>Base</Text>
      <Box display="flex" gap="4" mt="8">
        <Button variant="base">Base</Button>
        <Button variant="base-outline">Base outline</Button>
        <Button variant="base-soft-outline">Base soft outline</Button>
        <Button variant="base-text">Base text</Button>
      </Box>

      <Box display="flex" gap="4" mt="4">
        <Button isDisabled={true} variant="base">Base (disabled)</Button>
        <Button isDisabled={true} variant="base-outline">Base outline (disabled)</Button>
        <Button isDisabled={true} variant="base-soft-outline">Base soft outline (disabled)</Button>
        <Button isDisabled={true} variant="base-text">Base text (disabled)</Button>
      </Box>

      <Box display="flex" gap="4" mt="4">
        <Button variant="base" size="xl">XL xlarge</Button>
        <Button variant="base" size="lg">L large</Button>
        <Button variant="base" size="md">MD medium</Button>
        <Button variant="base" size="sm">SM small</Button>
        <Button variant="base" size="xs">XS xsmall</Button>
      </Box>
      <Text as="h4" mt={8}>Secondary</Text>
      <Box display="flex" gap="4">
        <Button variant="secondary">Secondary</Button>
        <Button variant="secondary-outline">Secondary outline</Button>
        <Button variant="secondary-soft-outline">Secondary soft outline</Button>
        <Button variant="secondary-text">Secondary text</Button>
      </Box>

      <Box display="flex" gap="4" mt="4">
        <Button isDisabled={true} variant="secondary">Secondary (disabled)</Button>
        <Button isDisabled={true} variant="secondary-outline">Secondary outline (disabled)</Button>
        <Button isDisabled={true} variant="secondary-soft-outline">Secondary soft outline (disabled)</Button>
        <Button isDisabled={true} variant="secondary-text">Secondary text (disabled)</Button>
      </Box>
    
    </Container>
  );
}

export default Sandbox;
